import { render } from "./RgpdPage.vue?vue&type=template&id=4224b97c&scoped=true"
import script from "./RgpdPage.vue?vue&type=script&lang=js"
export * from "./RgpdPage.vue?vue&type=script&lang=js"

import "./RgpdPage.vue?vue&type=style&index=0&id=4224b97c&scoped=true&lang=css"

import exportComponent from "/webserver/websites/dev/intrapaf-v2-public-client-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4224b97c"]])

export default __exports__